import { api } from "./api";
import type {
  FiltroDesempenho,
  TreinamentosDesempenho,
  FilasDesempenho,
  PatrulhasDesempenho,
  RMDesempenho,
  RMODesempenho,
  OficialDesempenho,
} from "../types/desempenho";

export const desempenhoService = {
  async getTreinamentosDesempenho(
    filtro: FiltroDesempenho
  ): Promise<TreinamentosDesempenho> {
    const response = await api.get("/desempenho/treinamentos", {
      params: filtro,
    });
    return response.data;
  },

  async getFilasDesempenho(filtro: FiltroDesempenho): Promise<FilasDesempenho> {
    const response = await api.get("/desempenho/filas", {
      params: filtro,
    });
    return response.data;
  },

  async getPatrulhasDesempenho(
    filtro: FiltroDesempenho
  ): Promise<PatrulhasDesempenho> {
    const response = await api.get("/desempenho/patrulhas", {
      params: filtro,
    });
    return response.data;
  },

  async getRMDesempenho(filtro: FiltroDesempenho): Promise<RMDesempenho> {
    const response = await api.get("/desempenho/rm", {
      params: filtro,
    });
    return response.data;
  },

  async getRMODesempenho(filtro: FiltroDesempenho): Promise<RMODesempenho> {
    const response = await api.get("/desempenho/rmo", {
      params: filtro,
    });
    return response.data;
  },

  async getOficialDesempenho(
    filtro: FiltroDesempenho & { militarId: string }
  ): Promise<OficialDesempenho> {
    const response = await api.get("/desempenho/oficial", {
      params: filtro,
    });
    return response.data;
  },
};
